import "./assets/styles/main-ltr.scss";


import 'bootstrap';
// import 'classie';
require('./assets/scripts/smooth-scroll.js');
require('./assets/scripts/parallax.min.js');
require('./assets/scripts/auto-hide-header.js');
require('./assets/scripts/bootstrap-datepicker.min.js');



require('./assets/scripts/e-motion-validate.js');
require('./assets/scripts/jquery.custom-file-input.js');
require('./assets/scripts/modernizr-custom.js');
require('./assets/scripts/classie.js');
// if(document.querySelector("#somedialog")) {
require('./assets/scripts/dialogFx.js');
// }
require('./assets/scripts/dialogFx_download.js');
require('./assets/scripts/parallex-effect.js');
// require('./assets/scripts/particles-ramadan.js');
require('./assets/scripts/preloader.js');
require('./assets/scripts/selectFx.js');
require('./assets/scripts/accordion.js');
require('./assets/scripts/custom.js');
